import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "OBSESSED | Gym Wear za trening, stil i rezultate";

const TITLES = {
  "/": BASE,
  "/prodavnica": "Prodavnica | OBSESSED",
  "/korpa": "Korpa | OBSESSED",
  "/checkout": "Poručivanje | OBSESSED",
  "/dostava": "Dostava | OBSESSED",
  "/o-nama": "O nama | OBSESSED",
  "/administracija": "Prijava | OBSESSED",
  "/uspesna-porudzbina": "Hvala na porudžbini | OBSESSED",
};

// Postavlja document.title po ruti. Za /proizvod/:id naslov postavlja
// ProductPage kada proizvod stigne sa API-ja.
const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/kontrolna-tabla")) {
      document.title = "Admin | OBSESSED";
      return;
    }
    if (pathname.startsWith("/proizvod/")) return;
    document.title = TITLES[pathname] || BASE;
  }, [pathname]);

  return null;
};

export default PageTitle;
